/**
 * @namespace Stores
 * @category Stores
 * @module map-context-store
 */

const createState = () => ({
  isVisible: false,
  menu: false,
  lat: null,
  lng: null,
  selectedOption: '',
  mapContextRoutes: ['location', 'diagnostics', 'sensors', 'events'],
})

export default {
  namespaced: true,
  state: createState(),
  getters: {
    showMapContextMenu: (state) => (routeName) => {
      return state.mapContextRoutes.some((route) => routeName.includes(route))
    },
  },
  mutations: {
    // Update a single state value
    updateState(state, { key, value }) {
      if (Object.prototype.hasOwnProperty.call(state, key)) {
        state[key] = value
      } else {
        console.warn(`Invalid state key: "${key}"`)
      }
    },
  },
}
